export default __webpack_public_path__ + "static/product-soap-b76d66157baecfb081c2ea0591f99219.png";